export enum ChangeRequestStepStatus {
    Approved = 'approved',
    Denied = 'denied',
    ForcedApproved = 'forcedApproved',
    ForcedDenied = 'forcedDenied',
    Cancelled = 'cancelled',
    Pending = 'pending',
    Submitted = 'submitted',
    EffectiveAt = 'effectiveAt',
    Completed = 'completed',
}
